import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSnackbarSuccess } from "../../../../Utils/helper";

export const PackageCategory = ({
  header,
  setHeader,
  searchFilter,
  setIsOpenSetting,
  setFacilityGrp,
}) => {
  const dispatch = useDispatch();
  const TestPackageCreationReducer = useSelector(
    (state) => state?.TestPackageCreationReducer?.getFacilityCategoryNetwork
  );


  return (
    <div>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">Choose To Filter Table</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          data-bs-dismiss="modal"
          onClick={() => {
            setIsOpenSetting(false);
          }}
        ></button>
      </div>
      <div className="select-time-interval ps-3 pe-3" style={{ height: "80%" }}>
        {TestPackageCreationReducer?.map((ele, index) => (
          <div className="d-flex ">
            <div style={{ fontSize: "15px", padding: "3px" }}>
              <input
                className="form-check-input"
                type="checkbox"
                checked={header?.some((element) => element === ele)}
                onClick={(e) => {
                  if (e.target.checked) {
                    if (header?.length === 5) {
                      getSnackbarSuccess(
                        "warning",
                        "You can select only 5 facility at a time",
                        dispatch
                      );
                    }else {
                        setHeader([...header, ele]);
                    }
                  } else {
                    let arr = header.filter((item) => item !== ele);
                    setHeader(arr);
                  }
                }}
              />
            </div>
            <label style={{ fontSize: "13px", padding: "3px" }}>
              {ele?.facilityCategory}
            </label>
          </div>
        ))}
      </div>
      <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0">
        {/* <div>
            <input
              type="checkbox"
              className="form-check-input"
              onClick={(e) => {
                handleSelectAll(e);
              }}
              checked={
                header?.length === selectHeader.length
                  
              }
            />
            <label
              className="margin-right"
              style={{ marginLeft: "10px", fontWeight: "600" }}
            >
              Select All
            </label>
          </div> */}
        <div>
          <button
            type="button"
            className="savedetails"
            aria-label="Close"
            data-bs-dismiss="modal"
            onClick={() => {
                if(header.length < 5){
                    getSnackbarSuccess("error","Please select at least 5 facility",dispatch)
                } else {
                    setFacilityGrp(header);
                    setIsOpenSetting(false);
                }
            }}
          >
            Show Selected
          </button>
        </div>
      </div>
    </div>
  );
};
